export const storybookScrollTop = () => {
    let button = document.getElementById("scrollTopButton");
    if(button){
        button.addEventListener("click", () => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        })
    }
}